/* eslint-disable */
import { browser } from '../ws-hybrid';
import { load } from '../ws-util';
/**
 * @class ComPageVisiable
 * @example
 * import wslib from '@tencent/weishi-lib';
 * wslib.wsCommon.pageVisiable.init();
 * document.body.addEventListener('innerVisibilityChange', (e) => console.log(e.detail));
 * or
 * import { wsCommon } from '@tencent/weishi-lib';
 * wsCommon.pageVisiable.init();
 * document.body.addEventListener('innerVisibilityChange', (e) => console.log(e.detail));
 */
class ComPageVisiable {
  constructor() {
    this.mqqApiUrl = '//open.mobile.qq.com/sdk/qqapi.js?_bid=152';
    this.needBind = true;
    this.hidden = '';
    this.visibilityChange = '';
    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
      this.hidden = 'hidden';
      this.visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      this.hidden = 'msHidden';
      this.visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      this.hidden = 'webkitHidden';
      this.visibilityChange = 'webkitvisibilitychange';
    }
    this._inited = undefined;
    this._appVisible = undefined;
    this._pageVisible = undefined;
    this._currVisible = undefined;
    this._triggered = undefined;
  }

  checkVisible(reason) {
    console.log('check visible', `reason=${reason}`, `appv=${this._appVisible}`, `pagev=${this._pageVisible}`);
    if (this._appVisible == undefined || this._pageVisible == undefined) {
      return;
    }
    const v = !!(this._appVisible && this._pageVisible);
    if (v !== this._currVisible) {
      this._currVisible = v;
      this._triggered = true;
      // $('body').trigger('innerVisibilityChange', { visible: this._currVisible, appVisible: this._appVisible, pageVisible: this._pageVisible });
      const customEvent = new CustomEvent(
        'innerVisibilityChange',
        {
          detail: {
            visible: this._currVisible,
            appVisible: this._appVisible,
            pageVisible: this._pageVisible,
          },
        },
      );
      document.body.dispatchEvent(customEvent);
    }
  }

  /**
   * check is visiable
   * @method
   */
  isVisible() {
    return this._currVisible;
  }

  /**
   * custom page visiable event initial
   * @method
   */
  init() {
    if (this._inited) {
      return;
    }
    this._inited = true;

    if (!this.needBind) {
      this._appVisible = true;
      this._pageVisible = true;
      this.checkVisible('notneed');
    } else if (!(document.addEventListener && this.hidden)) {
      this._appVisible = true;
      this._pageVisible = true;
      this.checkVisible('notsupport');
    } else {
      // _pageVisible
      document.addEventListener(this.visibilityChange, () => {
        this._pageVisible = !document[this.hidden];
        this.checkVisible('pagechange');
      }, false);
      this._pageVisible = !document[this.hidden];
      console.log('init page visible', this._pageVisible);

      // _appVisible
      if (browser.client == 'qzone') {
        if (window.mqq) {
          this.mqqInvokeInQz();
        } else {
          load.loadJs(this.mqqApiUrl, () => this.mqqInvokeInQz());
          // console.log('no mqq in qzone');
          // this._appVisible = true;
        }
      } else if (browser.client == 'qq') {
        if (window.mqq) {
          this.mqqInvokeInQQ();
        } else {
          // console.log('no mqq in qq');
          // this._appVisible = true;
          load.loadJs(this.mqqApiUrl, () => this.mqqInvokeInQQ());
        }
      } else {
        console.log('other client');
        this._appVisible = true;
      }

      this.checkVisible('init');

      // 预防客户端不回调
      setTimeout(() => {
        if (!this._triggered) {
          this._appVisible = true;
          this.checkVisible('timeout');
        }
      }, 1000);
    }
  }

  mqqInvokeInQz() {
    if (browser.platform == 'ios') {
      window.mqq.addEventListener('pageVisibility', (result) => {
        // result.data.isBackground app是否在后台，1/0
        // result.data.visible webview是否可见，1/0，7.7版本新增
        if (result.data.isBackground !== undefined) {
          const v = !result.data.isBackground;
          if (v === this._appVisible) {
            return;
          }
          this._appVisible = v;
          this.checkVisible('appchange');
        }
      });
      window.mqq.invoke('game', 'getPageVisibility', (result) => {
        // result.data app是否在前台，true/false
        // result.visible webview是否可见，true/false，7.7版本新增
        if (result.data !== undefined) {
          this._appVisible = !!result.data;
          console.log('init app visible', this._appVisible);
          this.checkVisible('checkapp');
        }
      });
    } else {
      window.mqq.addEventListener('pageVisibility', (result) => {
        // result.data.visible app是否在前台
        // result.data.hidden webview是否隐藏，暂不支持
        if (result.data.visible !== undefined) {
          const v = !!result.data.visible;
          if (v === this._appVisible) {
            return;
          }
          this._appVisible = v;
          this.checkVisible('appchange');
        }
      });
      window.mqq.invoke('ui', 'pageVisibility', { isWebviewCheck: 1 }, (result) => {
        // result.data.visible app是否在前台
        // result.data.hidden webview是否隐藏，暂不支持
        if (result.data.visible !== undefined) {
          this._appVisible = !!result.data.visible;
          console.log('init app visible', this._appVisible);
          this.checkVisible('checkapp');
        }
      });
    }
  }

  mqqInvokeInQQ() {
    document.addEventListener('qbrowserVisibilityChange', (result) => {
      // result.hidden，true/false
      if (result.hidden !== undefined) {
        const v = !result.hidden;
        if (v === this._appVisible) {
          return;
        }
        this._appVisible = v;
        this.checkVisible('appchange');
      }
    });
    window.mqq.ui.pageVisibility((result) => {
      // result，true/false
      if (result !== undefined) {
        this._appVisible = !!result;
        console.log('init app visible', this._appVisible);
        this.checkVisible('checkapp');
      }
    });
  }
}

export default new ComPageVisiable();
